import React from "react";
import { Button } from "@mui/material";
import styles from "./ConfirmacaoDados.module.css";
import { useNavigate } from "react-router-dom";
import { useCadastro } from "../../../resources/CadastroProvider";
import ShowDadosCard from "../../atoms/ShowDadosCard/ShowDadosCard";

const descriptionsPessoais = {
  rg: "RG",
  emissor: "Órgão Emissor",
  uf: "UF",
  identidade_genero: "Identidade de Gênero",
  data_nascimento: "Data de Nascimento",
  escolaridade: "Escolaridade",
  profissao: "Profissão",
  possui_nome_social: "Possui Nome Social",
  nome_social: "Nome Social",
  possui_deficiencia: "Possui Deficiência",
};

/*const descriptionsResidenciais = {
  cep: "CEP",
  logradouro: "Logradouro",
  numero: "Número",
  complemento: "Complemento",
  bairro: "Bairro",
  cidade: "Cidade",
  uf: "UF",
};*/

const descriptionsContato = {
  telefone_residencial: "Telefone Residencial",
  telefone_celular: "Telefone Celular",
  possui_whatsapp: "Possui WhatsApp",
  telefone_institucional: "Telefone Institucional",
  email_institucional: "E-mail Institucional",
};

/*const descriptionsProfissionais = {
  ambito: "Âmbito",
  lotacao: "Lotação",
  municipio: "Município",
  diretoria_regional: "Diretoria Regional",
  unidade: "Unidade",
  orgao_atuacao: "Órgão de Atuação",
  area_atuacao: "Área de Atuação",
  servico_programa: "Serviço ou Programa",
  beneficio: "Benefício",
  nivel_complexidade: "Nível de Complexidade",
  vinculo_empregaticio: "Vínculo Empregatício",
  funcao_desempenhada: "Função Desempenhada",
};*/

const ConfirmacaoDados: React.FC = () => {
  const {
    steps,
    userData,
    personalData,
    contactData,
  } = useCadastro();
  const navigate = useNavigate();

  function handleSectionChange(position: string) {
    const index = steps.findIndex((step) => step.label === position);
    navigate(`/cadastro/${index + 1}`);
  }

  /*
  const handleSubmit = async () => {
    // Separar os dados de deficiência do personalData corretamente
    const deficiencyData = personalData.possui_deficiencia
      ? { deficiencia: disabilities }
      : null;

    // Copiar os dados pessoais e remover as chaves relacionadas à deficiência
    const { possui_deficiencia, nome_social, ...filteredPersonalData } =
      personalData;

    // Criar o payload no formato esperado
    const payload = {
      userData: {
        nome: userData.nome,
        email: userData.email,
        provedor: userData.provedor,
        tipo_usuario: userData.tipo,
        CPF: userData.cpf,
        senha: userData.senha,
      },
      personalData: filteredPersonalData,
      addressData,
      contactData,
      professionalData,
      deficiencyData,
    };

    try {
      const response = await axios.post(
        `${API_URL}/cadastronovoparticipante`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
        },
      );
      if (response.status === 200) {
        alert("Dados confirmados e enviados com sucesso!");
        navigate(`/login`);
      } else {
        alert("Houve um erro ao enviar os dados. Por favor, tente novamente.");
      }
    } catch (error) {
      console.error("Erro ao enviar os dados:", error);
      alert("Houve um erro ao enviar os dados. Por favor, tente novamente.");
    }
  };*/

  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <h1 className={styles.title}>
          Confirmação de Dados do Cadastro
        </h1>

        <div className={styles.group}>
          <ShowDadosCard
            title="Dados do Usuário"
            descriptions={{ nome: "Nome", email: "Email", cpf: "CPF" }}
            data={{
              nome: userData.nome || "Não informado",
              email:userData.email,
              provedor: userData.provedor ?? "Não informado",
              cpf: userData.cpf || "Não informado",
            }}
          />

          <div className={styles.cardContainer}>
            <ShowDadosCard
              title="Dados de Contato"
              descriptions={descriptionsContato}
              data={contactData}
            />
            <div className={styles.buttoncontainer}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => handleSectionChange("Dados de Contato")}
              >
                Voltar
              </Button>
            </div>
          </div>

          <div className={styles.cardContainer}>
            <ShowDadosCard
              title="Dados Pessoais"
              descriptions={descriptionsPessoais}
              data={personalData}
            />
            <div className={styles.buttoncontainer}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => handleSectionChange("Dados Pessoais")}
              >
                Voltar
              </Button>
            </div>
          </div>







        </div>

        <div className="flex justify-center gap-4 pt-4">
          <button className="bg-gray-300 text-gray-700 px-6 py-2 rounded-xl hover:bg-gray-400 transition">
            Voltar
          </button>
          <button className="bg-blue-600 text-white px-6 py-2 rounded-xl hover:bg-blue-700 transition">
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmacaoDados;


/*
<ConfirmationCard title="Dados do Usuário">
            <p><span className="font-semibold">Nome:</span> {usuario.nome}</p>
            <p><span className="font-semibold">CPF:</span> {usuario.cpf}</p>
            <p><span className="font-semibold">Nascimento:</span> {usuario.nascimento}</p>
          </ConfirmationCard>



<div className={styles.section}>
          <div className={styles.cardContainer}>
            <ShowDadosCard
              title="Dados do Usuário"
              descriptions={{ nome: "Nome", email: "Email", cpf: "CPF" }}
              data={{
                nome: userData.nome || "Não informado",
                email:
                  `${userData.email}${userData.provedor}` || "Não informado",
                cpf: userData.cpf || "Não informado",
              }}
            />
            <div className={styles.buttoncontainer}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => handleSectionChange("Cadastro de Usuário")}
              >
                Voltar
              </Button>
            </div>
          </div>
          <div className={styles.cardContainer}>
            <ShowDadosCard
              title="Dados de Contato"
              descriptions={descriptionsContato}
              data={contactData}
            />
            <div className={styles.buttoncontainer}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => handleSectionChange("Dados de Contato")}
              >
                Voltar
              </Button>
            </div>
          </div>
        </div>











// dados pessoais
<div className={styles.section}>
          <div className={styles.cardContainer}>
            <ShowDadosCard
              title="Dados Pessoais"
              descriptions={descriptionsPessoais}
              data={personalData}
            />
            <div className={styles.buttoncontainer}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => handleSectionChange("Dados Pessoais")}
              >
                Voltar
              </Button>
            </div>
          </div>
          
        </div>



<div className={styles.cardContainer}>
            <ShowDadosCard
              title="Dados de Endereço"
              descriptions={descriptionsResidenciais}
              data={addressData}
            />
            <div className={styles.buttoncontainer}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => handleSectionChange("Dados de Endereço")}
              >
                Voltar
              </Button>
            </div>
          </div>




        <div className={styles.section}>
          <div className={styles.cardContainer}>
            <ShowDadosCard
              title="Dados Profissionais"
              descriptions={descriptionsProfissionais}
              data={professionalData}
            />
            <div className={styles.buttoncontainer}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => handleSectionChange("Dados Profissionais")}
              >
                Voltar
              </Button>
            </div>
          </div>
        </div>





        <div className={styles.buttoncontainer}>
        <Button className={styles.backbutton} onClick={handlePrevStep}>
          Voltar
        </Button>
        <Button
          variant="contained"
          color="primary"
          className={styles.nextbutton}
          onClick={handleSubmit}
        >
          Confirmar Dados
        </Button>
      </div>
*/